export function flattenMessages(nestedMessages, prefix = '') {
  return Object.keys(nestedMessages || {}).reduce((messages, key) => {
    const value = nestedMessages[key]
    const prefixedKey = prefix ? `${prefix}.${key}` : key
    if (typeof value === 'string')
      messages[prefixedKey] = value
    else
      Object.assign(messages, flattenMessages(value, prefixedKey))
    return messages
  }, {})
}

Number.prototype.mod = function(n) {
  return ((this % n) + n) % n
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function downloadFile(blob, fileName){
  const aElement = document.createElement('a');
  aElement.setAttribute('download', fileName);
  const href = URL.createObjectURL(blob);
  aElement.href = href;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  URL.revokeObjectURL(href);
};

export function downloadUrl(url, name){
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name;
      link.click();
  })
  .catch(console.error);
};

export function getImageSize(file) {
  return new Promise (function (resolved, rejected) {
    var i = new Image()
    i.onload = function(){
      resolved({ width: i.width, height: i.height})
    }
    i.src = file
  })
}

export function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}
